import { getClient } from '@/lib/restClient';
import { MenuManagementBrandMenuHourService } from '@/services/BrandMenuHour/MenuManagementBrandMenuHourService';

export const useMenuManagementDeleteBrandMenuHour = async (
  id: string
): Promise<void> => {
  const menuManagementBrandMenuHourService =
    new MenuManagementBrandMenuHourService(getClient());
  return menuManagementBrandMenuHourService.delete(id);
};
